module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_03_1280_1280_th-1ee321084cba9b9775fa6cc257671571.jpg";